var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check_container",on:{"click":_vm.check}},[_c('GI',{staticClass:"pointer",class:[_vm.disabled && 'disabled'],attrs:{"name":_vm.active === true ? 'brand_checked' : 'brand_unchecked',"ws":"24","hs":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }